exports = module.exports = require("../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".VirtualSelectGrid {\n  z-index: 1;\n}\n\n.VirtualizedSelectOption {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 0 .5rem;\n  cursor: pointer;\n}\n.VirtualizedSelectFocusedOption {\n  background-color: rgba(0, 126, 255, 0.1);\n}\n.VirtualizedSelectDisabledOption {\n  opacity: 0.5;\n}\n.VirtualizedSelectSelectedOption {\n  font-weight: bold;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/css-loader!/root/social-native/socialnative-web/node_modules/postcss-loader/src??ref--3-2!/root/social-native/socialnative-web/node_modules/react-virtualized-select/styles.css
// module id = 2586
// module chunks = 69